export default __webpack_public_path__ + "static/media/image-cover.61db6936.png";